// Legacy role names in API paths/JSON are retained; these types describe
// integration configuration, independently of platform permissions.
export enum IntegrationBindingTarget {
  ATTACHED_ROLE_TYPE_NOT_SET = 0,
  COMPANY = 1,
  PROFILE = 2,
  USER = 3,
}

export type IntegrationDefinition = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  globalAttributes: Record<string, string>;
  description?: string | null;
};

// LIST is an identity summary; editors load values through an explicit READ.
export type IntegrationDefinitionSummary = Pick<
  IntegrationDefinition,
  'id' | 'createdAt' | 'updatedAt' | 'name' | 'description'
>;

export type IntegrationBinding = {
  id: string;
  createdAt: string;
  updatedAt: string;
  roleId: string;
  type: IntegrationBindingTarget;
  customAttributes: Record<string, string>;
  companyId: string;
  userId: string;
  profileId: string;
  role: IntegrationDefinition;
};

// Company and profile reads contain identity only; editors query configuration.
export type IntegrationBindingSummary = Pick<
  IntegrationBinding,
  | 'id'
  | 'createdAt'
  | 'updatedAt'
  | 'type'
  | 'companyId'
  | 'userId'
  | 'profileId'
> & {
  role: Pick<
    IntegrationDefinition,
    'id' | 'createdAt' | 'updatedAt' | 'name' | 'description'
  >;
};
